import { z } from "zod";
import { agendaItem_BlockerZodObject } from "./agenda-item-blocker";
import { agendaItem_DropInZodObject } from "./agenda-item-drop-in";
import { agendaItem_ExternalICalOrderZodObject } from "./agenda-item-external-ical-order";
import { agendaItem_ExternalThirdPartyOrderZodObject } from "./agenda-item-external-third-party-order";
import { agendaItem_ReservationZodObject } from "./agenda-item-reservation";

const agendaItemZodUnion = z.union([
    agendaItem_DropInZodObject,
    agendaItem_BlockerZodObject,
    agendaItem_ReservationZodObject,
    agendaItem_ExternalICalOrderZodObject,
    agendaItem_ExternalThirdPartyOrderZodObject,
]);

type AgendaItem = z.infer<typeof agendaItemZodUnion>;

export { agendaItemZodUnion };
export type { AgendaItem };
